import React, { useState } from "react";
import {
  Form,
  Button,
  Container,
  Row,
  Col,
  FloatingLabel,
} from "react-bootstrap";
import DatePicker from "react-datepicker";
import CustomModal from "../components/CustomModal";
import axios from "axios";
import { API_URL } from "../Config";

const DemoRequest = () => {
  const [selected_date, setSelectedDate] = useState(new Date());
  const [selected_time, setSelectedTime] = useState("");
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile_number: "",
    message: "",
    selected_date: "",
    selected_time: "",
  });

  // Time slots for selection
  const timeSlots = [
    "10:00 AM - 10:30 AM",
    "10:30 AM - 11:00 AM",
    "11:00 AM - 11:30 AM",
    "11:30 AM - 12:00 AM",
    "12:00 PM - 12:30 PM",
    "12:30 AM - 01:00 PM",
    "01:00 PM - 01:30 PM",
    "01:30 AM - 02:00 PM",
    "02:00 PM - 02:30 PM",
    "02:30 AM - 03:00 PM",
    "03:00 PM - 03:30 PM",
    "03:30 AM - 04:00 PM",
    "04:00 PM - 04:30 PM",
    "04:30 PM - 05:00 PM",
  ];

  const handleTimeSelect = (time) => {
    setSelectedTime(time);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      //console.log("Form Data:", formData);
      if (!selected_date || !selected_time) {
        setModalConfig({
          show: true,
          title: "Error",
          body: "Please select a date and time.!",
          type: "error",
        });
        return;
      } else {
        try {
          formData.selected_date = selected_date.toString();
          formData.selected_time = selected_time;
          var url = API_URL + "inquiry/demoRequest";
          const response = await axios.post(url, formData);
          setModalConfig({
            show: true,
            title: "Success",
            body:
              "Dear " +
              formData.name +
              ", your demo is scheduled for " +
              selected_date.toDateString() +
              " at " +
              selected_time,
            type: "success",
          });
          setSuccess(true);
          setFormData({
            name: "",
            email: "",
            mobile_number: "",
            message: "",
            selected_date: "",
            selected_time: "",
          });
        } catch (error) {
          // Handle any error          
          if (error.response) {
            // The server responded with an error
            setErrors("Error response:" + error.response.data);
          }
        } finally {
          setIsSubmitting(false);
        }
      }
    } else {
      setSuccess(false);
    }
  };

  // Handle form field changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value, });
  };

  // Form validation
  const validateForm = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = "Name is required.";
    if (!formData.email) {
      newErrors.email = "Email is required.";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Invalid email format.";
    }
    if (!formData.mobile_number) {
      newErrors.mobile_number = "Mobile number is required.";
    } else if (!/^\d{10}$/.test(formData.mobile_number)) {
      newErrors.mobile_number = "Mobile number must be 10 digits.";
    }
    if (!formData.message) newErrors.message = "Message is required.";
    return newErrors;
  };

  const [modalConfig, setModalConfig] = useState({
    show: false,
    title: "",
    body: "",
    type: "",
  });

  const handleCloseModal = () => {
    setModalConfig({ ...modalConfig, show: false });
  };

  return (
    <div>
      <Container className="collaborate-section rounded ">
        <p className="text-center">
          <span className="highlight-text text-center mb-4">
            Select a Date, Time & Enter the details to schedule demo
          </span>
        </p>
        <div>
          {/* Calendar Section */}
          <Row className="py-4">
            <Col className="text-center">
              <DatePicker
                selected={selected_date}
                minDate={new Date()}
                onChange={(date) => setSelectedDate(date)}
                inline
                value={formData.selected_date}
              />
            </Col>
            <Col xs={6}>
              <div className="text-left">
                {timeSlots.map((time, index) => (
                  <Button
                    key={index}
                    variant={
                      selected_time === time ? "primary" : "outline-primary"
                    }
                    className="m-2"
                    onClick={() => handleTimeSelect(time)}
                    value={formData.selected_time}
                  >
                    {time}
                  </Button>
                ))}
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center my-3">
            <Col xs={12} md={8}>
              <Form onSubmit={handleSubmit}>
                <Form.Group>
                  <FloatingLabel
                    controlId="floatingInput"
                    label="Enter your Name"
                    className="mb-3"
                  >
                    <Form.Control
                      type="text"
                      placeholder="Enter your name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      isInvalid={!!errors.name}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.name}
                    </Form.Control.Feedback>
                  </FloatingLabel>
                </Form.Group>

                <Form.Group>
                  <FloatingLabel
                    controlId="floatingInput"
                    label="Enter your Email"
                    className="mb-3"
                  >
                    <Form.Control
                      type="email"
                      placeholder="Enter your email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      isInvalid={!!errors.email}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.email}
                    </Form.Control.Feedback>
                  </FloatingLabel>
                </Form.Group>

                <Form.Group>
                  <FloatingLabel
                    controlId="floatingInput"
                    label="Enter your Mobile Number"
                    className="mb-3"
                  >
                    <Form.Control
                      type="text"
                      placeholder="Enter your mobile number"
                      name="mobile_number"
                      value={formData.mobile_number}
                      onChange={handleChange}
                      isInvalid={!!errors.mobile_number}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.mobile}
                    </Form.Control.Feedback>
                  </FloatingLabel>
                </Form.Group>

                <Form.Group>
                  <FloatingLabel
                    controlId="floatingInput"
                    label="Message"
                    className="mb-3"
                  >
                    <Form.Control
                      as="textarea"
                      rows={10}
                      style={{ height: "100px" }}
                      placeholder="Enter your message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      isInvalid={!!errors.message}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.message}
                    </Form.Control.Feedback>
                  </FloatingLabel>
                </Form.Group>
              </Form>
            </Col>
          </Row>
        </div>
        {/* Submit Button */}
        <Row md={2} className="justify-content-center mt-4">
          <Col md={6} className="text-center">
            <h5 className="mb-3 text-center">
              {selected_date.toDateString()} {selected_time}
            </h5>
          </Col>
          <Col>
            <Button
              variant="primary"
              type="submit"
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Confirming Schedule..." : "Confirm Schedule"}
            </Button>
          </Col>
        </Row>
      </Container>
      <CustomModal
        show={modalConfig.show}
        title={modalConfig.title}
        body={modalConfig.body}
        type={modalConfig.type}
        onClose={handleCloseModal}
      />
    </div>
  );
};

export default DemoRequest;
